import Schrank from "./Schrank";
import Brett from "./Brett";

export default class Deckel {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    schrank: Schrank;
    box = new THREE.Box3();
    product: Object;
    boeden: Array;

    constructor(schrank) {
        this.schrank = schrank;
        this.product = APP.findProduct('Deckel');
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    get parent() {
        return this.schrank;
    }

    compile() {
        this._compileChildren();

        this.box = new THREE.Box3().makeEmpty();
        this.boeden.forEach(b=>this.box.union(b.box));
    }

    _compileChildren() {
        this.schrank.elements.forEach(e => e.deckel = []);

        const lazyBoeden = APP.model.lazyPool(this, 'boeden', () => new Brett(this.schrank, 'Deckel', 'xz'));

        const createDeckel = (box, elements) => {
            const deckelStaerke = APP.settings.getFloat('deckel_staerke');
            box.min.y = box.max.y;
            box.max.y += deckelStaerke;

            const nextBoden = (pushAsElementDeckel=true) => {
                const boden = lazyBoeden.next();
                if (pushAsElementDeckel) {
                    elements.forEach(e => e.deckel.push(boden));
                }
                if (elements.length == 1) {
                    boden.element = elements[0];
                }
                return boden;
            }

            if (this.schrank.angleSide === 'back') {
                const boden = nextBoden();
                boden.box = box.clone();
                boden.box.min.z = this.schrank.size.z - this.schrank.sizeTop.z;
                boden.boxToVertices();
                boden.xEdgeZY(0, 0).z = this.schrank.slopings.zOfY(boden.box.min.y, box.min.z, deckelStaerke);
                boden.updateBox();

                const boden2 = nextBoden(false);
                boden2.box = box.clone();
                boden2.boxToVertices();
                boden2.xEdgeZY(1, 0)._ = boden.xEdgeZY(0, 0);
                boden2.xEdgeZY(1, 1)._ = boden.xEdgeZY(0, 1);
                boden2.xEdgeZY(0, 1)._ = {y: this.schrank.slopings.yOfZ(box.min.z, 0, 0), z: box.min.z};
                boden2.xEdgeZY(0, 0)._ = {y: this.schrank.slopings.yOfZ(box.min.z, deckelStaerke, deckelStaerke), z: box.min.z};
                boden2.updateBox();
                boden2.mainAxes = 'yz';
                boden2.inSketch = false;

            } else {
                box.min.z = this.schrank.corpusBox.min.z;

                if (this.schrank.slopings.isSloped(box)) {
                    if (this.schrank.slopings.isBroken(box)) {
                        const boden = nextBoden();
                        boden.box = box.clone();
                        boden.box.max.x = this.schrank.slopeX;
                        boden.box.min.y = this.schrank.slopings.yOfX(box.min.x, deckelStaerke);
                        boden.boxToVertices();
                        boden.zEdgeXY(0, 1).y = this.schrank.slopings.yOfX(box.min.x, 0);
                        boden.zEdgeXY(1, 0)._ = {
                            x: this.schrank.slopings.xOfY(box.min.y, deckelStaerke),
                            y: box.min.y
                        };
                        boden.updateBox();

                        const boden2 = nextBoden();
                        boden2.box = box.clone();
                        boden2.boxToVertices();
                        boden2.zEdgeXY(0, 1)._ = boden.zEdgeXY(1, 1);
                        boden2.zEdgeXY(0, 0)._ = boden.zEdgeXY(1, 0);
                        boden2.zEdgeXY(1, 1).y = this.schrank.slopings.yOfX(box.max.x, 0);
                        boden2.zEdgeXY(1, 0).y = this.schrank.slopings.yOfX(box.max.x, deckelStaerke);
                        boden2.updateBox();
                    } else {
                        const boden = nextBoden();
                        boden.box = box.clone();
                        boden.box.min.y = this.schrank.slopings.yOfX(box.min.x, deckelStaerke);
                        boden.box.max.y = this.schrank.slopings.yOfX(box.max.x, 0);
                        boden.boxToVertices();
                        boden.zEdgeXY(0, 1).y = this.schrank.slopings.yOfX(box.min.x, 0);
                        boden.zEdgeXY(1, 0).y = this.schrank.slopings.yOfX(box.max.x, deckelStaerke);
                        boden.updateBox();
                    }
                } else {
                    const boden = nextBoden();
                    boden.box = box.clone();
                    boden.boxToVertices();
                }
            }
        };

        if (this.needEinzelneDeckel) {
            this.schrank.elements.forEach(element => {
                createDeckel(element.box.clone(), [element])
            });
        } else {
            const box = this.schrank.elementsBox.clone();
            box.min.x = this.schrank.corpusBox.min.x;
            box.max.x = this.schrank.corpusBox.max.x;
            if (APP.settings.getBool('aussenwand_durchgehend_oben',false)) {
                const aussenwand_staerke = APP.settings.getFloat('aussenwand_staerke');
                box.min.x += aussenwand_staerke;
                box.max.x -= aussenwand_staerke;
            }
            createDeckel(box, this.schrank.elements);
        }

        lazyBoeden.cleanup();
        this.boeden.forEach(x => x.compile());
    }

    get needEinzelneDeckel() {
        if (this.arrangement.isShojituer()) {
            return false;
        }
        if (this.schrank.angleSide === 'left' || this.schrank.angleSide === 'right' || this.schrank.angleSide === 'back' || this.schrank.elements.some(e => e.locked.y)) {
            return true;
        } else {
            return this.schrank.size.y > APP.settings.getMinValue('einzelne_deckel');
        }
    }

    get flaechenMass() {
        const result = new THREE.Vector3(0, 0, 0);
        this.boeden.forEach(boden => {
            result.x += boden.flaechenMass.x;
            result.y = Math.max(result.y, boden.flaechenMass.y);
            result.z = Math.max(result.z, boden.flaechenMass.z)
        });
        return result;
    }

    get materialArtikelnummer() {
        return this.boeden[0].materialArtikelnummer;
    }

    get size() {
        return this.flaechenMass;
    }

    iterate(iterator) {
        iterator(this);
        this.boeden.forEach(x=>x.iterate(iterator));
    }

}
